import paymentMethods from "./paymentMethods/paymentMethods-slice";
import notification from "./notification/notification-slice";
import accounts from "./account/account-slice";
import common from "./common/common-slice";
import paymentActility from "./paymentActivity/paymentActivity-slice";
import config from "./config/config-slice";
import user from "./user/user-slice";
import payments from "./payments/payments-slice";
import accountSummary from "./accountSummary/accountSummary-slice";
import schedule from "./schedulePayments/schedulePayments-slice";
import statements from "./statements/statements-slice";
import receipt from "./receipt/receipt-slice";
import payByText from "./paybytext/paybytext-slice";

const reducer = {
  notification,
  accounts,
  common,
  paymentMethods,
  paymentActility,
  config,
  user,
  payments,
  accountSummary,
  schedule,
  statements,
  receipt,
  payByText,
};

export default reducer;
